// What the erasure screens still share (D83, D92): the kind's name (the Erasures list) and the
// steps after which a failed erasure is only retried (the list and the organization's erasure).
// The rest moved to the kit's StatusWord, the screens' own forms and OrgErasure (APS-412).
import type { Erasure } from '../api/queries'
import type { MessageId } from '../i18n'

export const KIND_KEY: Record<Erasure['kind'], MessageId> = {
  organization: 'erasure.kind.organization',
  user: 'erasure.kind.user',
  app_user: 'erasure.kind.appUser',
  project: 'erasure.kind.project',
}

/** The steps after which a failed erasure is retried, never aborted (the database agrees). */
export const IRREVERSIBLE = ['kv', 'clickhouse', 'tenants', 'objects', 'identity', 'postgres']
